<script setup lang="ts">
import { computed } from 'vue';
import type { DropdownItems } from '../Dropdown.vue';
import Dropdown from '../Dropdown.vue';

import { countries } from '@/assets/json/countries.json';

const value = defineModel<string>('value', { required: true });

const countryOptions = computed<DropdownItems[]>(() => countries.map((name) => ({ name, value: name })));
</script>

<template>
  <div>
    <Dropdown input-class="country" v-model:value="value" :options="countryOptions" />
  </div>
</template>

<style>
.country {
  border: 1px solid var(--gray-alt);
}
</style>
